/**
 * Collections, and the works and grants that live under one.
 */
import type {
  CollectionSummary,
  CollectionsResponse,
  CreateCollectionRequest,
  RegisterWorkRequest,
  ShareCollectionRequest,
  WorkSummary,
  WorksResponse,
} from "@ondo/shared";

import { request } from "./request.ts";

export const fetchCollections = () =>
  request<CollectionsResponse>("/collections").then((body) => body.collections);

export const createCollection = (body: CreateCollectionRequest) =>
  request<CollectionSummary>("/collections", body);

export const fetchCollectionWorks = (collectionId: string) =>
  request<WorksResponse>(`/collections/${collectionId}/works`).then((body) => body.works);

export const registerWork = (collectionId: string, body: RegisterWorkRequest) =>
  request<WorkSummary>(`/collections/${collectionId}/works`, body);

export const shareCollection = (collectionId: string, body: ShareCollectionRequest) =>
  request<{ shared: true }>(`/collections/${collectionId}/grants`, body);
